import AuthLogin from "./login.vue";
import AuthReset from "./reset.vue";
import AuthForgot from "./forgot.vue";

const userRoutes = [
  {
    path: "/login",
    component: AuthLogin,
    name: "auth.login",
    meta: {
      auth: false
    }
  },
  {
    path: "/password/reset*",
    component: AuthReset,
    name: "auth.reset",
    meta: {
      auth: false
    }
  },
  {
    path: "/password/forgot",
    component: AuthForgot,
    name: "auth.forgot",
    meta: {
      auth: false
    }
  }
];

export default userRoutes;
